module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMi40IDMyLjQiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE4LjE0LDYuNDdhMS44NiwxLjg2LDAsMCwxLTIsMS45NCwxLjg5LDEuODksMCwwLDEtMS45MS0xLjk0LDEuOTMsMS45MywwLDAsMSwyLTJBMS44NywxLjg3LDAsMCwxLDE4LjE0LDYuNDdaTTE0LjYyLDI4Ljc2VjExLjM2aDMuMTZ2MTcuNFoiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/racing/info-transparent.svg
// module id = lvaz
// module chunks = 13